import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../../style/page.css'


function NotFound() {
    const navigate = useNavigate()
    return (
        <div className='notFound'>
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={<Button type="primary" onClick={() => navigate(-1)}>Go Back</Button>}
            />

        </div>
    )
}

export default NotFound